import React from 'react';
import { Box, CircularProgress, Container, Typography } from '@mui/material';

interface FileManagerLoadingStateProps {
  message?: string;
}

/**
 * Standardized loading state component for file manager operations
 */
export const FileManagerLoadingState: React.FC<
  FileManagerLoadingStateProps
> = ({ message = 'Loading...' }) => (
  <Container maxWidth="lg" sx={{ mt: 4 }}>
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="200px"
    >
      <CircularProgress size={40} />
      <Typography variant="body1" sx={{ mt: 2 }} color="text.secondary">
        {message}
      </Typography>
    </Box>
  </Container>
);
